import 'aframe'

import { Entity } from 'aframe-react'
import React, { Component } from 'react'

class SectorJumper extends Component {
  render () {
    const { name, position, color, onClick } = this.props
    return (
      <Entity
        position={position}
        primitive='a-plane'
        color={color}
        height='0.08'
        width='0.1'
        transparent
        opacity={0.5}
        text={`value:${name}; align: center; width: 0.8`}
        events={{
          click: onClick
        }}
      />
    )
  }
}

export default SectorJumper
